export const MAX_CHAT_COMMENTS = 15;
export const MAX_PAGE_SIZE = 1000;
export const DEFAULT_PAGE_SIZE = 20;
